import { AnyRequestActionType, anyRequestStart } from 'src/store/anyRequest/slice';
import { store } from 'src/store/store';
import { SafeAnyType } from 'src/utils/safeAny';

export const dispatchAnyRequestStart = (data: AnyRequestActionType<SafeAnyType>) => {
  store.dispatch<SafeAnyType>(anyRequestStart(data));
};
